import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2)
    },
    "& label": {
      marginTop: '-3px', // fix the icon alignment issue
    },
  },
  mt2: {
    marginTop: theme.spacing(2),
  },
  mt1: {
    marginTop: theme.spacing(1),
  },
  ml2: {
    marginLeft: theme.spacing(2),
  },
  horizontalSpacer: {
    height: '30px'
  },
  siteContainer: {
    border: 1,
    padding: theme.spacing(2)
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  pFormControl: {
    margin: `${theme.spacing(2)} 0px`,
    width: '100%',
  },
  indentedFields: {
    margin: theme.spacing(2),
    width: '100%',
  },
  rightAlign: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  dfe: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },
  easyRosterInfoText: {
    fontStyle: 'italic',
    fontSize: '12px'
  },
  saveBtn: {
    alignSelf: 'center',
  },
  label: {
    // display: "inline-flex",
    // alignItems: "center"
    pointerEvents: "auto"
  },

  cbs: {
    width: '100%'
  },
  flex: {
    display: 'flex'
  },
  formButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: '10px'
  },
  button: {
    borderRadius: '100px',
  },
  hover: {
    borderRadius: '8px',
    position: 'relative',
    paddingLeft: '5px',
    '&:hover': {
      'background-color': theme.palette.action.hover,
    },
    width: '90%'
  },
  siteStepBackGround: {
    borderRadius: '8px',
    position: 'relative',
    paddingLeft: '5px',
    'background-color': theme.palette.action.hover,
    width: '90%'
  },
  deletedStep: {
    color: "red",
    textDecoration: "line-through"
  },
  addedStep: {
    color: "green",
  }
});
